<template>
  <div class="integrity__main">
    <div class="ui-tabs">
      <ul class="ui-tabs__ul">
        <li
          v-for="tab in tabs"
          :key="tab.id"
          class="ui-tabs__tab"
          :class="[activeTab === tab.id ? 'ui-tabs__tab--active' : 'ui-tabs__tab']"
          @click="onChangeTab(tab.id)"
        >
          {{ tab.label }}
        </li>
      </ul>
      <div class="ui-tabs__content" v-if="!isLoading">
        <Intro
          v-if="activeTab === integrityKey.intro"
          @categoryUpdated="onCategoryUpdated"
        />
        <!-- Reusable component to upload files on specific submodules-->
        <FileUploader
          :key="activeTabKey"
          :category="integrityComplianceKey.integrity"
          :subcategory="activeTab"
          :files="categoryFiles"
          :title="getActiveTab.label"
          @createdFile="onCreatedFile"
          v-if="activeTab === integrityKey.groupEssentials || activeTab === integrityKey.groupValues"
        />
        <Events
          :key="activeTabKey"
          :detail="subcategoryDetail"
          @subcategoryUpdated="onSubcategoryUpdated"
          v-if="activeTab === integrityKey.events"
        />
        <Statistics
          :key="activeTabKey"
          :detail="subcategoryDetail"
          v-if="activeTab === integrityKey.statistics"
        />
      </div>
    </div>
  </div>
</template>


<script>
const Intro = () => import("@/components/IntegrityCompliance/Integrity/Intro");
const Events = () => import("@/components/IntegrityCompliance/Integrity/Events/Events");
const Statistics = () => import("@/components/IntegrityCompliance/Integrity/Statistics");
const FileUploader = () => import("@/components/IntegrityCompliance/FileUploader");

import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

import { integrityKey, integrityComplianceKey } from "@/lib/constants.js";

export default {
  inject: ['IC_getMainCategory'],
  components: {
    Intro,
    Events,
    Statistics,
    FileUploader
  },
  computed: {
    tabs() {
      return [
        {
          id: integrityKey.intro,
          label: this.$t("integrityCompliance.integrity.intro")
        },
        {
          id: integrityKey.groupEssentials,
          label: this.$t("integrityCompliance.integrity.group_essencials")
        },
        {
          id: integrityKey.groupValues,
          label: this.$t("integrityCompliance.group_values")
        },
        {
          id: integrityKey.events,
          label: this.$t("integrityCompliance.integrity.events")
        },
        {
          id: integrityKey.statistics,
          label: this.$t("integrityCompliance.integrity.statistics")
        }
      ]
    },
    categoryFiles () {
      return this.category.files
    },
    getActiveTab() {
      return this.tabs.find(({ id }) => id === this.activeTab)
    },
    subcategoryDetail() {
      const subcategory = this.category.subcategories.find(({ name }) => name === this.activeTab);
      const subcategoryDetail = subcategory && subcategory.id ? subcategory : {};
      return subcategoryDetail;
    }
  },
  data () {
    return {
      isLoading: false,
      category: {},
      activeTab: integrityKey.intro,
      integrityKey,
      integrityComplianceKey
    }
  },
  async mounted () {
    this.category = this.IC_getMainCategory();
    await this.getCategoryDetail();
  },
  methods: {
    onChangeTab(tabId) {
      this.activeTab = tabId;
      this.activeTabKey = `${this.activeTab}_${new Date().getTime()}`;
    },
    async getCategoryDetail () {
      try {
        this.isLoading = true;
        this.category = await api.getCategory(this.category.id);
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.integrity.getError'),
          show: true,
          type: "error"
        });
      } finally {
        this.isLoading = false;
      }
    },
    onCreatedFile (fileData) {
      this.category.files.push(fileData);
    },
    onCategoryUpdated (categoryData) {
      this.$emit('categoryUpdated', categoryData)
    },
    onSubcategoryUpdated (subcategoryData) {
      const subcategories = this.category.subcategories.map(subcategory => {
        if (subcategory.id === subcategoryData.id) {
          return {
            id: subcategory.id,
            name: subcategoryData.name,
            title: subcategoryData.title,
            description: subcategoryData.description,
            is_parent: subcategory.is_parent
          }
        } else {
          return subcategory
        }
      })
      this.category.subcategories = subcategories;
    }
  }

}
</script>
